import { makeAutoObservable, runInAction} from 'mobx'
import { http } from '@/utils'

class DistrictStore {

    //数据列表初始化
    dataList = [];

    //总条数
    total = '';

    //条数
    pagesize = 10;

    //当前页
    page = 1;

    //查询字段
    title=''

    constructor() {
        makeAutoObservable(this)
    }
    //数据获取
    getDataList = async () => {
        const res = await http.get(`/adminapi/zoning?page=${this.page}&pagesize=${this.pagesize}&title=${this.title}`)
        if (res.data.code === 200) {
            runInAction(() => {
                this.dataList = JSON.parse(JSON.stringify(res.data.data.data))
                this.total = res.data.data.total
            })
        }
    }
}

export { DistrictStore }